import { type FC } from 'react'

import { ProductHeadRatingAndQuestions } from '../ProductRating'

import { ProductHeadLabels } from './ProductHeadLabels'
import { ProductHeadTitle } from './ProductHeadTitle'

export const ProductHead: FC = () => (
  <>
    <div className="flex flex-col pb-2.5 tablet:flex-row">
      <ProductHeadTitle />
      <ProductHeadRatingAndQuestions />
    </div>
    <ProductHeadLabels />
  </>
)
